import { Injectable } from '@angular/core';
import { BaseApiService } from '../../common/base-api.service';
import { HttpClient, HttpEvent, HttpEventType, HttpRequest } from '@angular/common/http';
import { SettingsProviderService } from '../../common/settings-provider.service';
import { Observable, of } from 'rxjs';
import { IEntityDocumentSummary } from '../../message-models/entity-document-summary';
import { DocumentTypeService } from '../../services/document-type.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentService extends BaseApiService {

  constructor(http: HttpClient,
    private documentTypeService: DocumentTypeService) {
    super(http, new SettingsProviderService('ecaApi'), 'Document');
  }

  getDocumentForViewOrDownload(documentId: string): Observable<HttpEvent<Blob>> {
    return this.http.request(new HttpRequest(
      'POST',
      this.baseUrl + 'GetDocumentForViewOrDownload',
      { documentId },
      {
        reportProgress: true,
        responseType: 'blob'
      }));
  }

  downloadOrOpenDocument(documentSummary: IEntityDocumentSummary, withDownload = false) {
    this.getDocumentForViewOrDownload(documentSummary.documentId).subscribe(
      fileContentResult => {
        switch (fileContentResult.type) {
          case HttpEventType.UploadProgress:
            break;
          case HttpEventType.DownloadProgress:
            break;
          case HttpEventType.Response:
            const downloadedFile = new Blob([fileContentResult.body], {
              type: fileContentResult.body.type
            });
            const a = document.createElement('a');
            a.download = documentSummary.originalFilename;

            a.setAttribute('style', 'display:none;');
            document.body.appendChild(a);
            a.href = URL.createObjectURL(downloadedFile);

            a.target = '_blank';
            if (!withDownload && documentSummary.canPreviewDocument) {
              const url = window.URL.createObjectURL(downloadedFile);
              window.open(url);// Does not show the file name in the tab title.
            } else {
              a.click();
            }
            document.body.removeChild(a);
            break;
        }
      }, error => {
      });
  }
}

